(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let draggedFrame = null;

    function moveTo(frame, clientX) {
      const rect = frame.getBoundingClientRect();
      if (!rect.width) return;

      const percent = Math.min(Math.max(((clientX - rect.left) / rect.width) * 100, 0), 100);
      frame.style.setProperty('--position', `${percent}%`);

      const range = frame.querySelector('[data-before-after-range]');
      if (range) range.value = String(Math.round(percent));
    }

    // Keyboard and assistive technology drive the range input directly.
    document.addEventListener('input', (event) => {
      const range = event.target.closest('[data-before-after-range]');
      if (!range) return;

      const frame = range.closest('[data-before-after]');
      if (frame) frame.style.setProperty('--position', `${range.value}%`);
    });

    // Mouse, pen and touch all arrive as pointer events.
    document.addEventListener('pointerdown', (event) => {
      const frame = event.target.closest('[data-before-after]');
      if (!frame) return;

      // Stops the browser turning the press into a native drag or selection.
      event.preventDefault();

      draggedFrame = frame;
      frame.setPointerCapture?.(event.pointerId);
      moveTo(frame, event.clientX);
    });

    document.addEventListener('pointermove', (event) => {
      if (!draggedFrame) return;

      // Stops the browser from turning the drag into a text selection.
      event.preventDefault();
      moveTo(draggedFrame, event.clientX);
    });

    const endDrag = () => {
      draggedFrame = null;
    };

    document.addEventListener('pointerup', endDrag);
    document.addEventListener('pointercancel', endDrag);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    const drawer = () => document.querySelector('[data-cart-drawer]');

    function open() {
      const el = drawer();
      if (el && !el.open) el.showModal();
    }

    function syncHeaderCount(root) {
      const source = root.querySelector('[data-cart-count-source]');
      const badge = document.querySelector('[data-cart-count]');
      if (!source || !badge) return;

      const count = Number(source.textContent.trim()) || 0;
      badge.textContent = String(count);
      badge.hidden = count === 0;
    }

    // Pulls fresh markup for this section and swaps it into the open dialog, so
    // the drawer keeps its open state and focus.
    async function refresh() {
      const el = drawer();
      if (!el) return;

      const response = await fetch(el.dataset.cartSectionUrl);
      if (!response.ok) return;

      const data = await response.json();
      const markup = data['cart-drawer'];
      if (!markup) return;

      const fresh = new DOMParser().parseFromString(markup, 'text/html').querySelector('[data-cart-content]');
      if (!fresh) return;

      el.querySelector('[data-cart-content]').replaceWith(fresh);
      syncHeaderCount(el);
    }

    async function send(url, body) {
      const el = drawer();
      if (el) el.dataset.busy = '';

      try {
        await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        await refresh();
      } finally {
        if (el) delete el.dataset.busy;
      }
    }

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-cart-open]')) {
        event.preventDefault();
        open();
        return;
      }

      if (event.target.closest('[data-cart-close]')) {
        const el = drawer();
        if (el) el.close();
        return;
      }

      const line = event.target.closest('[data-cart-line]');
      if (line) {
        const el = drawer();
        if (!el) return;

        send(`${el.dataset.cartChangeUrl}.js`, {
          line: Number(line.dataset.cartLine),
          quantity: Number(line.dataset.cartQuantity),
        });
      }
    });

    // Clicking the dim area outside the panel closes the drawer.
    document.addEventListener('click', (event) => {
      const el = drawer();
      if (!el || !el.open || event.target !== el) return;
      el.close();
    });

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('form[action*="/cart/add"]');
      if (!form) return;

      const el = drawer();
      if (!el) return;

      event.preventDefault();

      // The button spins on its own; the whole drawer only dims once it is the
      // thing being updated, which is after the response comes back.
      const button = form.querySelector('[type="submit"]');
      if (button) button.dataset.loading = '';

      fetch(`${el.dataset.cartAddUrl}.js`, { method: 'POST', body: new FormData(form) })
        .then(() => refresh())
        .then(() => open())
        .finally(() => {
          if (button) delete button.dataset.loading;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dealer-form"] && !Shopify.designMode) return;
  try {
    
  /**
   * Adds the scheme the dealer left off, so the address that reaches the inbox
   * is clickable. Runs on submit rather than on blur: rewriting a field while
   * someone is still filling the form in is startling, and they may well come
   * back to it.
   */
  document.addEventListener('submit', (event) => {
    const field = event.target.querySelector('[data-website-field]');
    if (!field) return;

    const typed = field.value.trim();
    if (typed === '') return;

    if (!/^https?:\/\//i.test(typed)) {
      field.value = 'https://' + typed.replace(/^\/+/, '');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  /* Accordion behaviour: opening one question closes the others in the same list. */
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.faq-item__question');
    if (!summary) return;

    const item = summary.parentElement;
    const list = item.closest('.faq__list');
    if (!list || item.open) return;

    // `item.open` is still the pre-toggle state here, so this runs only when the
    // clicked question is about to open.
    list.querySelectorAll('.faq-item[open]').forEach((other) => {
      if (other !== item) other.open = false;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    function track(gallery) {
      return gallery.querySelector('[data-gallery-track]');
    }

    function scrollToIndex(gallery, index) {
      const el = track(gallery);
      if (!el) return;

      const max = el.scrollWidth - el.clientWidth;
      const target = Math.min(Math.max(index * el.clientWidth, 0), max);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      el.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    function currentIndex(el) {
      return el.clientWidth ? Math.round(el.scrollLeft / el.clientWidth) : 0;
    }

    document.addEventListener('click', (event) => {
      const step = event.target.closest('[data-quantity-step]');
      if (step) {
        const input = step.closest('[data-quantity]').querySelector('[data-quantity-input]');
        const min = Number(input.min) || 1;
        input.value = String(Math.max(min, (Number(input.value) || min) + Number(step.dataset.quantityStep)));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      const gallery = event.target.closest('[data-gallery]');
      if (!gallery) return;

      const thumb = event.target.closest('[data-gallery-thumb]');
      if (thumb) {
        scrollToIndex(gallery, Number(thumb.dataset.galleryThumb));
        return;
      }

      const arrow = event.target.closest('[data-gallery-prev], [data-gallery-next]');
      if (!arrow) return;

      const direction = arrow.hasAttribute('data-gallery-prev') ? -1 : 1;
      scrollToIndex(gallery, currentIndex(track(gallery)) + direction);
    });

    // Reveal the sticky buy bar once the main add-to-cart button has scrolled
    // off the top of the viewport.
    const anchor = document.querySelector('[data-buy-anchor]');
    const bar = document.querySelector('[data-buy-bar]');

    if (anchor && bar) {
      const updateBar = () => {
        bar.hidden = anchor.getBoundingClientRect().bottom > 0;
      };

      window.addEventListener('scroll', updateBar, { passive: true });
      window.addEventListener('resize', updateBar);
      updateBar();
    }

    // Mirrors the chosen variant into the sticky bar's hidden field.
    document.addEventListener('change', (event) => {
      const select = event.target.closest('.product__field select[name="id"]');
      if (!select) return;

      const mirror = document.querySelector('[data-buy-bar-variant]');
      if (mirror) mirror.value = select.value;
    });

    // Keeps the active thumbnail in sync with swiping and arrow navigation.
    document.addEventListener(
      'scroll',
      (event) => {
        const el = event.target.closest && event.target.closest('[data-gallery-track]');
        if (!el) return;

        const active = currentIndex(el);
        el.closest('[data-gallery]')
          .querySelectorAll('[data-gallery-thumb]')
          .forEach((thumb) => {
            const isActive = Number(thumb.dataset.galleryThumb) === active;
            if (isActive) {
              thumb.setAttribute('aria-current', 'true');
              thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
            } else {
              thumb.removeAttribute('aria-current');
            }
          });
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('input', (event) => {
    const field = event.target.closest('[data-locator-filter]');
    if (!field) return;

    const locator = field.closest('[data-locator]');
    const query = field.value.trim().toLowerCase();
    let matches = 0;

    locator.querySelectorAll('[data-locator-group]').forEach((group) => {
      let visibleInGroup = 0;

      group.querySelectorAll('[data-locator-store]').forEach((store) => {
        const hit = !query || store.dataset.locatorStore.includes(query);
        store.hidden = !hit;
        if (hit) visibleInGroup += 1;
      });

      group.hidden = visibleInGroup === 0;
      matches += visibleInGroup;
    });

    const empty = locator.querySelector('[data-locator-empty]');
    if (empty) empty.hidden = matches > 0;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const NARROW = '(max-width: 749px)';
    /* Pixels per second. Slow enough to read a label as it goes past. */
    const SPEED = 42;

    function setup(bar) {
      const marquee = bar.querySelector('[data-trust-marquee]');
      const track = bar.querySelector('[data-trust-track]');
      if (!marquee || !track) return;

      if (!marquee.dataset.cloned) {
        const copy = track.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        copy.removeAttribute('data-trust-track');

        /* The copy must not answer to the theme editor: two elements claiming
           the same block would confuse selection and highlighting. */
        copy.querySelectorAll('[data-shopify-editor-block]').forEach((node) => {
          node.removeAttribute('data-shopify-editor-block');
        });

        marquee.append(copy);
        marquee.dataset.cloned = 'true';
      }

      const narrow = window.matchMedia(NARROW).matches;
      const overflows = track.scrollWidth > bar.clientWidth;

      bar.classList.toggle('trust-bar--marquee', narrow && overflows);
      marquee.style.setProperty(
        '--marquee-duration',
        Math.max(12, Math.round(track.scrollWidth / SPEED)) + 's'
      );
    }

    function setupAll() {
      document.querySelectorAll('.trust-bar').forEach(setup);
    }

    setupAll();

    let pending;
    window.addEventListener('resize', () => {
      clearTimeout(pending);
      pending = setTimeout(setupAll, 200);
    });

    /* A section re-rendered in the theme editor arrives without any of this. */
    document.addEventListener('shopify:section:load', setupAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (!button) return;

    const carousel = button.closest('[data-carousel]');
    const track = carousel && carousel.querySelector('[data-carousel-track]');
    if (!track) return;

    const card = track.firstElementChild;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const step = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    const direction = button.hasAttribute('data-carousel-prev') ? -1 : 1;

    // Clamp to the scrollable range: a smooth scroll aimed past either end is
    // dropped by the browser, which would leave the last card unreachable.
    const maxScroll = track.scrollWidth - track.clientWidth;
    const target = Math.min(Math.max(track.scrollLeft + step * direction, 0), maxScroll);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    track.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' });
  });

  } catch(e) { console.error(e); }
})();
})();
